export const COMMUNICATION_REQUEST = "COMMUNICATION_REQUEST";
export const COMMUNICATION_SUCCESS = "COMMUNICATION_SUCCESS";
export const COMMUNICATION_FAIL = "COMMUNICATION_FAIL";
export const COMMUNICATION_CLEAR_ERRORS = "COMMUNICATION_CLEAR_ERRORS";